type StepStatus = 'current' | 'upcoming' | 'complete';

export type OnboardingStep = {
  id: string;
  status: StepStatus;
};

export type OnboardingScreen = 'welcome' | 'terms' | 'cookies';

const STEP_POSITIONS = {
  'en-GB': { welcome: 1, terms: 2, cookies: 3, total: 3 },
  default: { welcome: 1, terms: 3, cookies: 4, total: 4 },
};

export const getOnboarding1NextPath = (locale: string): string =>
  locale === 'en-GB' ? '/' : '/onboarding/2';

export const getOnboardingSteps = (
  locale: string,
  screen: OnboardingScreen,
): OnboardingStep[] => {
  const config =
    locale === 'en-GB' ? STEP_POSITIONS['en-GB'] : STEP_POSITIONS.default;
  const current = config[screen];

  return Array.from({ length: config.total }, (_, index): OnboardingStep => {
    const stepNumber = index + 1;
    const status: StepStatus =
      stepNumber < current
        ? 'complete'
        : stepNumber === current
          ? 'current'
          : 'upcoming';
    return { id: String(stepNumber), status };
  });
};
